export const config = {
  eventGroup: '剑网3' /* 确定一下这个应该是英文 */,
  name: 'XXX',
  identify: 'other',
  eventTags: ['zshd', 'mo']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '加载活动页',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        }
      });
    },
    /**
     * @param {string} [status] - success/fail
     */
    clickConfirmInvited: function(status) {
      report({
        eventName: 'click_confirm_invited',
        eventDescription: '点击确定加入（被邀请）',
        eventDataValue: {
          status: status
        },
        types: {
          status: checkTypeHOF('string')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/tracker/create-tracker.js